import { urlApiReport } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IInsightListParams, IInsights, IInvoiceListingRecord, IInvoiceOpenRecord, IInvoiceOpenSalesRepRecord, IMyTaskRecord, IPaidAndLeftReviewRecord, IPaymentRecord, IReportListParams, IReportListResponse, IRoofs, IRoofsListParams, IShelbyvilleJob, IShelbyvilleJobListParams, IShingle, IShingleColor, IShingleColorListParams, IShingleListParams, IMyPaymentsRecord, IInProgressCompletedJobRecord } from '~/utils/interface/report';
import { IClosedInvoiceListParams, IClosedInvoiceListResponse } from '~/utils/interface/report';

const reportApi = {
    getClosedInvoices(params?: IClosedInvoiceListParams) {
        return axiosClient.get<IApiBaseResponse<IClosedInvoiceListResponse>>(`${urlApiReport.getClosedInvoices}`, {
            params,
        });
    },
    getMyTasks(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IMyTaskRecord>>>(`${urlApiReport.getMyTasks}`, {
            params,
        });
    },

    getInvoiceOpenSalesRep(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IInvoiceOpenSalesRepRecord>>>(`${urlApiReport.getInvoiceOpenSalesRep}`, {
            params,
        });
    },

    getPaidAndLeftReview(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IPaidAndLeftReviewRecord>>>(`${urlApiReport.getPaidAndLeftReview}`, {
            params,
        });
    },

    getPayments(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IPaymentRecord>>>(`${urlApiReport.getPayments}`, {
            params,
        });
    },
    getMyPayments(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IMyPaymentsRecord>>>(`${urlApiReport.getMyPayments}`, {
            params,
        });
    },
    getInvoiceOpen(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IInvoiceOpenRecord>>>(`${urlApiReport.getInvoiceOpen}`, {
            params,
        });
    },
    getInvoiceListing(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IInvoiceListingRecord>>>(`${urlApiReport.getInvoiceListing}`, {
            params,
        });
    },
    getJobsInProgressCompleteds(params?: IReportListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IInProgressCompletedJobRecord>>>(`${urlApiReport.getJobInProgressCompleted}`, {
            params,
        });
    },
    getRoofs(params?: IRoofsListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IRoofs>>>(`${urlApiReport.getRoofs}`, {
            params,
        });
    },
    getShelbyvilleJob(params?: IShelbyvilleJobListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IShelbyvilleJob>>>(`${urlApiReport.getShelbyvilleJob}`, {
            params,
        });
    },
    getShingleColor(params?: IShingleColorListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IShingleColor>>>(`${urlApiReport.getShingleColor}`, {
            params,
        });
    },
    getShingle(params?: IShingleListParams) {
        return axiosClient.get<IApiBaseResponse<IReportListResponse<IShingle>>>(`${urlApiReport.getShingle}`, {
            params,
        });
    },
    getInsights(params?: IInsightListParams) {
        return axiosClient.get<IApiBaseResponse<IInsights>>(`${urlApiReport.getInsights}`, {
            params,
        });
    },
};

export default reportApi;
